module.exports = [
  require('./derivative'),

  // simplify
  require('./simplify'),

  // decomposition
  require('./decomposition/lup'),
  require('./decomposition/slu'),

  // solver
  require('./solver/lsolve'),
  require('./solver/lusolve'),
  require('./solver/usolve')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/algebra/index.js
// module id = 1118
// module chunks = 0